import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-root"
}
const _hoisted_2 = { class: "start__modal-wrapper" }
const _hoisted_3 = { class: "start__modal-head" }
const _hoisted_4 = { class: "start__modal-scroll-container" }
const _hoisted_5 = { class: "start__modal-scroll-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  href: "https://rozklady.bielsko.pl/",
  class: "start__modal-link",
  target: "_blank",
  title: "Pokaż rozkłady"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }),
        _createElementVNode("div", {
          class: "start__modal",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.closeModal,
                class: "start__modal-close-btn",
                icon: "mdi mdi-close",
                variant: "text",
                "aria-label": "Zamknij okno"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "start__modal-link",
                  "aria-label": "Pokaż portal ITS Bielsko-Biała"
                }, [
                  (_ctx.getContrastActive)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require('@/assets/img/start_modal/app_startpage_itsbb_button_on_min.svg'),
                        alt: "ITS BB"
                      }, null, 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/img/start_modal/app_startpage_itsbb_button_off_min.svg'),
                        alt: "ITS BB"
                      }, null, 8, _hoisted_7))
                ]),
                _createElementVNode("a", _hoisted_8, [
                  (_ctx.getContrastActive)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require('@/assets/img/start_modal/app_startpage_transport_button_on_min.svg'),
                        alt: "Rozkłady"
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/img/start_modal/app_startpage_transport_button_off_min.svg'),
                        alt: "Rozkłady"
                      }, null, 8, _hoisted_10))
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}